import React, { useState, useEffect} from "react";
import { useNavigate } from 'react-router-dom';
import "./Profile.css";
import * as profileService from './services/profileService';
import { getUserData } from '../../shared/utils/authStorage';
import bellIcon from '../../shared/assets/icons/bell.png'; 
import profileIcon from '../../shared/assets/icons/profile.png';
import mail from '../../shared/assets/icons/mail.png';
import rightIcon from "../../shared/assets/icons/right.png";
import leftIcon from "../../shared/assets/icons/left.png";
import licence from "../../shared/assets/icons/license.png";
import address from "../../shared/assets/icons/address.png";
import logoIcon from "../../shared/assets/icons/logo-web.png";
import phone from "../../shared/assets/icons/phone.png";
import organisation from "../../shared/assets/icons/organisation.png";
import logout from "../../shared/assets/icons/logout.png";
import backIcon from '../../shared/assets/icons/back.png';
import backIconMobile from '../../shared/assets/icons/back_mob.png';
import { useAuth } from '../../contexts/AuthContext';
const Profile = () => {
  const [notificationsEnabled, setNotificationsEnabled] = useState(true);
  const navigate = useNavigate(); // Initialize useNavigate hook
  const [profileDetails, setProfileDetails] = useState({});
  const [userData, setUserData] = useState({});
  const { logout: authLogout } = useAuth();

  const logoutUser = async () => {
    try {
      authLogout();
      navigate('/');
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const fetchClientDetails = async () => {
      try {
        const data = await profileService.fetchClientDetails();
        setProfileDetails(data);
      } catch (error) {
        console.error('Error fetching client details:', error);
      }
    };
    
    const user = getUserData();
    setUserData(user || {});
    console.log('userData:', userData);
    console.log('user:', user);

    fetchClientDetails();
  }, []);
  return (
    <div className="profile-container">
       <div className="profile-container-web">
      {/* Header */}
      <header className="main-header">
                    <h1 className="app-title"></h1>
                    <div className="header-icons">
                                  <img src={bellIcon} alt="Notifications" className='notification-icon'/>
                                <img src={profileIcon} alt="Profile" className="icon profile-icon" />
                    </div>
                  </header>
                  <div className="inside-content">
          <div className="second-header">
                             <button className="back-button">
                                 <img src={backIcon} alt="Back" className="icon back-icon" onClick={() => navigate('/dashboard')}/>
                             </button>
                             <h2 className="title">Profile</h2>
                            
                         </div>
           
           {/* Stepper */}
    

      {/* Main Profile Section */}
      <div className="profile-content">
      

        {/* Contact Details */}
        <div className="contact-details">
          <div className="detail-item">
            
            <span>{userData.customer?.company_name || profileDetails.company_name}</span>
          </div>
          <div className="detail-item">
            <img src={phone} alt="Phone" className="icon" />
            <span>{userData.customer?.phone || profileDetails.phone_number}</span>
          </div>
          <div className="detail-item">
            <img src={mail} alt="Email" className="icon" />
            <span>{userData.email || profileDetails.mail_id}</span>
          </div>
          <div className="detail-item">
            <img src={address} alt="Location" className="icon" />
            <span>{userData.address?.address1}</span>
          </div>
          <div className="detail-item clickable" onClick={() => {logoutUser();}}>
          <img src={logout} alt="Logout" className="icon" />
          <span>Logout</span>
          </div>
        </div>
          {/* Profile Info Card */}
          <div className="profile-card">
            <img 
              src={profileIcon} 
              alt="Profile" 
              className="profile-image" 
            />
            <div className="profile-card-text">
              <h3>{profileDetails.first_name} {profileDetails.last_name}</h3>
            </div>
          </div>
      </div>

      
      </div>
    
     
    </div>
    <div className="profile-container-mobile">
      <header className="mobile-header">
               <div className="back-button">
                 <img src={backIconMobile} alt="Back" className="icon back-icon back-icon-mobile" onClick={() => navigate('/dashboard')}/>
               </div>
               <div className="main-mobile-header">
                 <h2 className="main-title">Profile</h2>
                </div>
                
                <div className="header-icons">
                        <img src={bellIcon} alt="Notifications" className="icon" />
                        </div>
              
               </header>

      <div className="profile-info">
        <img 
          src ={profileIcon} 
          alt="Profile" 
          className="profile-image"
        />
        <h3>{profileDetails.first_name}</h3>
      </div>

      <div className="profile-details">
        <div className="detail-item">
          <img src={organisation}alt="Organization" className="icon" />
          <span>{userData.customer?.company_name || profileDetails.company_name}</span>
        </div>
        <div className="detail-item">
          <img src={phone} alt="Phone" className="icon" />
          <span>{userData.customer?.phone || profileDetails.phone_number}</span>
        </div>
        <div className="detail-item">
          <img src={mail} alt="Email" className="icon" />
          <span>{userData.email || profileDetails.mail_id}</span>
        </div>
        <div className="detail-item">
          <img src={address} alt="Location" className="icon" />
          <span>{userData.address?.address1}</span>
        </div>
        <div className="detail-item clickable">
          <img src={licence} alt="Licence" className="icon" />
          <span>Licence</span>
          <button className="back-button">
                                 <img src={leftIcon} alt="Back" className="icon back-icon licence-arrow" onClick={() => navigate('/dashboard')}/>
                             </button>
        </div>
        <div className="detail-item">
          <img src={bellIcon} alt="Notification" className="icon" />
          <span>Push Notification</span>
          <label className="switch">
            <input 
              type="checkbox" 
              checked={notificationsEnabled} 
              onChange={() => setNotificationsEnabled(!notificationsEnabled)} 
            />
            <span className="slider round"></span>
          </label>
        </div>
        <div className="detail-item clickable" onClick={() => {logoutUser();}}>
          <img src={logout} alt="Logout" className="icon" />
          <span>Logout</span>
        </div>
      </div>

      <div className="app-version app-version-fixed">
        <span>App version</span>
        <span>V2.1.1</span>
      </div>
    </div>
    </div>
  );
};

export default Profile;
